import bootbox from 'bootbox';
import api from '../api';
import worldMap from '../core/map';
import translate from '../core/tools/translate';

import ShapesInfo from './ShapesInfo';
import { FeaturePermission } from '../../constants/feature.permission.helper';

const LayerControls = (name) => require('../controls').get(name);

class MarkedAreaInfo extends ShapesInfo {
    constructor () {
        const name = 'MarkedArea';

        const options = {
            layer: LayerControls(name).getLayer(),
            label: translate(`Common.${name}`),
            name,
            id: 'operational-area',
            context: 'operational-area'
        };

        super(options);

        this.getType = this.getType.bind(this);
    }

    static getInstance () {
        if (!MarkedAreaInfo._instance) {
            MarkedAreaInfo._instance = new MarkedAreaInfo();
        }

        return MarkedAreaInfo._instance;
    }

    _hasActions () {
        return false;
    }

    _hasSummary () {
        const instance = LayerControls(this.options.name);
        if (Number(instance.getTypeValue()) !== 15) {
            return api.authorization.isAuthorized(FeaturePermission.INFO_SUMMARY.show);
        }
    }

    _actionsOnClick (value) {
        const controls = LayerControls(this.options.name);

        switch (value) {
        case 'remove':
            return bootbox.dialog({
                title: `<i class="fa fa-warning"></i> ${translate('Common.Warning')}`,
                message: translate('Validation.RemoveLocation'),
                backdrop: false,
                buttons: {
                    main: {
                        label: `<i class="fa fa-times"></i> ${translate('Action.Cancel')}`,
                        className: 'btn-default'
                    },
                    danger: {
                        label: `<i class="fa fa-trash-o"></i> ${translate('Action.Remove')}`,
                        className: 'btn-danger',
                        callback () {
                            api.grouping.remove(controls.view.getLastSelectedAreaId());
                        }
                    }
                }
            });
        }
    }

    getType () {
        return LayerControls(this.options.name).get().scheme();
    }

    _filterByLocation (state) {
        super._filterByLocation(state);

        const layer = LayerControls(this.options.name).getLayer(worldMap.getCurrent(), 'MarkedAreaAdditional');
        const ids = [];
        if (state) {
            this.getEntryAsFeature().forEach((feature) => ids.push(feature.properties.Id));
        }

        const { remote } = layer.options;
        remote.params.overlap = ids.length ? ids.join(',') : undefined;
        layer.setOptions({ remote });

        if (layer.visible()) {
            layer.redraw();
        }
    }
}

export default MarkedAreaInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/MarkedAreaInfo.js